<template>
  <div id="actuatorManagement">
    <!-- 搜索栏 xxl-job-admin/jobgroup/index1-->
    <div class="search-box">
      <div></div>
      <div>
        <Button type="primary" icon="ios-add" @click="handleAddClick">新增执行器</Button>
      </div>
    </div>
    <!-- 表格 -->
    <el-table :columns="Columns" :tableData="tableData" :loading="tableLoading" :tableHeight="tableHeight"
      @on-btn-click="onBtnClick">
    </el-table>
    <!-- 分页 -->
    <div class="paging-box">
      <Page :current="page" :page-size="12" :total="totalCount" @on-change="handlePagingClick" />
    </div>
    <!-- 执行器弹框 -->
    <model-add v-if="modelStatus" :id="id" :modelStatus="modelStatus" :title="title" @handle-model="handleModel" />
    <div>
      <Alter ref="alterModal" :configData="configData" @change_ok="confirmDel"></Alter>
    </div>
  </div>
</template>
<script>
  import {
    mapActions
  } from "vuex";
  import elementResizeDetectorMaker from "element-resize-detector"; // 获取元素的高度
  import ElTable from '_g/commonComponent/table/elTable.vue';
  import Columns from './tableConfig.js';
  import ModelAdd from './Model';
  export default {
    components: {
      'el-table': ElTable,
      'model-add': ModelAdd
    },
    data() {
      return {
        tableData: [], // 数据
        Columns: [], // 表头
        totalCount: 100, // 总条数
        tableHeight: 0,
        searchValue: '', // 搜索框的值
        modelStatus: false, // 控制执行器显示
        title: '新增执行器',
        page: 1, // 当前页
        configData: {}, // 弹框配置信息
        id: '',
        tableLoading: true, // 表格loading
      }
    },
    methods: {
      ...mapActions([
        'sa_SpringJobGroupView_page', // 列表
        'sa_SpringJobGroupView_remove', // 删除
      ]),
      // 获取元素的高度
      getElementHeight() {
        let ERD = elementResizeDetectorMaker();
        let _this = this;
        ERD.listenTo(document.getElementById("actuatorManagement"), (element) => {
          _this.tableHeight = (element.scrollHeight - 66 - 90);
        });
      },
      // 操作按钮
      onBtnClick(rowItem, options) {
        console.log(rowItem, options)
        this.id = rowItem.id;
        switch (options.code) {
          case '删除':
            this.DeleteComponent();
            break;
          case '编辑':
            this.title = '编辑执行器';
            this.modelStatus = true;
            break;
          default:
            break;
        }
      },
      // 新建功能
      handleAddClick() {
        this.id = "";
        this.title = '新建执行器';
        this.modelStatus = true;
      },
      // 搜索功能
      handleSearchClick() {},
      // 分页功能
      handlePagingClick(res) {
        this.page = res;
      },
      // 新增执行器弹框回调
      handleModel(res) {
        this.modelStatus = false;
        this.page = 1;
        // 刷新页面
        this.sa_SpringJobGroupView_pages();
      },
      // 删除
      DeleteComponent() {
        this.configData = {
          type: "warning",
          title: "警告",
          content: "是否删除当前信息"
        };
        this.$refs.alterModal.OpenModal();
      },
      confirmDel() {
        // this.sa_SpringJobInfoView_removes();
        console.log('确定')
        this.sa_SpringJobGroupView_removes();
      },
      // 列表查询
      async sa_SpringJobGroupView_pages() {
        try {
          this.tableLoading = true;
          const parmas = {
            start: (this.page - 1) * 12,
            length: 12
          };
          const data = await this.sa_SpringJobGroupView_page(parmas);
          console.log(data, '---')
          this.tableData = data.data;
          this.totalCount = data.recordsTotal;
          this.tableLoading = false;
        } catch (error) {
          console.log(error);
          this.tableLoading = false;
        }
      },
      // 删除
      async sa_SpringJobGroupView_removes() {
        try {
          const data = await this.sa_SpringJobGroupView_remove({
            id: this.id
          });
          this.$Message.success('删除成功~~');
          // 刷新页面
          this.sa_SpringJobGroupView_pages();
        } catch (error) {
          console.log(error);
        }
      }
    },
    mounted() {
      this.Columns = Columns;
      // 获取元素高度
      this.getElementHeight();
      // 获取列表
      this.sa_SpringJobGroupView_pages();
    }
  }
</script>
<style lang="less" scoped>
  #actuatorManagement {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0 50px;
    box-sizing: border-box;

    .search-box {
      width: 100%;
      height: 66px;
      padding: 22px 0px 12px 0px;
      box-sizing: border-box;
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
    }

    .paging-box {
      position: fixed;
      bottom: 0px;
      right: 50px;
      z-index: 1;
      height: 60px;
      width: calc(100% - 250);
      text-align: right;
    }
  }
</style>